// Test IDs for the Pravidla (server rules) page.

export const RULES_PAGE = {
  section: "rules-page",
  heroSection: "rules-hero-section",
  toc: "rules-toc",
  tocLink: "rules-toc-link",
  ruleSection: "rules-rule-section",
  goldenRuleSection: "rules-golden-rule-section",
};
